var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ns-product-detail",
      class: { "is-sale": _vm.isSale },
      attrs: { itemscope: "", itemtype: "http://schema.org/Product" }
    },
    [
      !_vm.isBaseSku && !_vm.hideFavorites
        ? _c("div", { staticClass: "ns-product-detail__favorite" }, [
            _c(
              "div",
              {
                staticClass: "ns-product-detail__favorite-icon",
                class: { "is-favorite": _vm.isFavorite },
                attrs: {
                  "data-testid": "favoriteIcon",
                  "data-testid-value": _vm.isFavorite
                },
                on: {
                  click: _vm.handleFavoriteClick,
                  mouseover: function($event) {
                    return _vm.handleShowFavoritesText(true)
                  },
                  mouseleave: function($event) {
                    return _vm.handleShowFavoritesText(false)
                  }
                }
              },
              [
                _vm.isFavorite
                  ? _c("NsIcon", {
                      attrs: { "icon-name": "icon-favorite-heart-hollow" }
                    })
                  : _c("NsIcon", {
                      attrs: { "icon-name": "icon-favorite-heart" }
                    })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.showFavoritesText &&
                      _vm.$mq !== "mobile" &&
                      _vm.$mq !== "phablet",
                    expression:
                      "showFavoritesText && $mq !== 'mobile' && $mq !== 'phablet'"
                  }
                ],
                staticClass: "ns-product-detail__favorite-text"
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.translations.addToFavorites) +
                    "\n    "
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "ns-product-detail__main-content" }, [
        _c("div", { staticClass: "ns-product-detail__body--left" }, [
          _c(
            "div",
            { staticClass: "ns-product-detail__images" },
            [
              _vm.image.contentType === "img" &&
              ((_vm.$mq !== "mobile" && _vm.$mq !== "phablet") ||
                _vm.imageSet.length <= 1)
                ? _c(
                    "NsImage",
                    {
                      staticClass: "ns-product-detail__active-image",
                      class: { transitioning: _vm.slideTransitioning },
                      attrs: {
                        src: _vm.image.src,
                        alt: _vm.image.alt,
                        "fallback-src": _vm.imageFallbackSrc,
                        "maintain-ratio": "1x1",
                        "image-fit": "contain",
                        "use-src-set": "",
                        itemprop: "image"
                      }
                    },
                    [
                      _vm.isSale && _vm.salesLabel
                        ? _c(
                            "div",
                            { staticClass: "ns-product-detail__sales-label" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.salesLabel) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.image.contentType === "video" &&
              ((_vm.$mq !== "mobile" && _vm.$mq !== "phablet") ||
                _vm.imageSet.length <= 1)
                ? _c(
                    "video",
                    {
                      key: _vm.image.src,
                      ref: "activeVideo",
                      staticClass:
                        "ns-product-detail__active-image ns-product-detail__active-video",
                      attrs: { controls: "" }
                    },
                    [_c("source", { attrs: { src: _vm.image.src } })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.imageSet.length > 1
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "ns-product-detail-carousel__slide-number"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.slideIndex + 1) +
                            " / " +
                            _vm._s(_vm.imageSet.length) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("NsProductDetailCarousel", {
                      attrs: {
                        "image-set": _vm.imageSet,
                        "slide-index": _vm.slideIndex
                      },
                      on: { "slide-select": _vm.handleSlideSelect }
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ns-product-detail__body--right" },
          [
            _c("h1", {
              staticClass: "ns-product-detail__title",
              attrs: { itemprop: "name" },
              domProps: { innerHTML: _vm._s(_vm.title) }
            }),
            _vm._v(" "),
            _vm.sizeWeight
              ? _c(
                  "div",
                  {
                    staticClass: "ns-product-detail__size-weight",
                    attrs: { itemprop: "weight" }
                  },
                  [
                    _c("span", { attrs: { "data-testid": "sizeLabel" } }, [
                      _vm._v(_vm._s(_vm.translations.size))
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "ns-product-detail__weight",
                      attrs: { "data-testid": "sizeWeight" },
                      domProps: { innerHTML: _vm._s(_vm.sizeWeight) }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showPrices
              ? _c("NsProductPrice", {
                  staticClass: "ns-product-detail__price",
                  attrs: {
                    "adr-only": _vm.showAdrOnly,
                    "adr-price": _vm.adrPrice,
                    "adr-price-label": _vm.translations.adrPriceLabel,
                    "adr-price-type": _vm.adrPriceType,
                    "is-base-sku": _vm.isBaseSku,
                    "min-price": _vm.minPrice,
                    "max-price": _vm.maxPrice,
                    "original-price": _vm.originalPrice,
                    "original-price-label": _vm.originalPriceLabel,
                    "original-price-type": _vm.originalPriceType,
                    price: _vm.price,
                    "price-label": _vm.priceLabel,
                    "price-type": _vm.priceType,
                    "show-labels": _vm.showPriceLabels,
                    "show-original-crossed-out": _vm.showOriginalCrossedOut,
                    "show-adr-price": _vm.showAdrPrice,
                    "hide-adr-override": _vm.hideAdr
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showSkuPoints
              ? _c("NsProductSkuPoints", {
                  staticClass: "ns-product-detail__sku-points",
                  attrs: {
                    forcesv: _vm.forcesv,
                    "hide-sku": _vm.hideSku,
                    "is-distributor": _vm.isDistributor,
                    points: _vm.points,
                    sku: _vm.sku,
                    translations: _vm.translations,
                    "is-product-detail": ""
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isLoyaltyEnabled
              ? _c("NsLoyaltyInformation", {
                  staticClass: "ns-product-detail__loyalty-information",
                  attrs: {
                    translations: _vm.translations,
                    "is-logged-in": _vm.isLoggedIn,
                    "is-opted-in": _vm.userLoyalty.optInStatus,
                    "loyalty-status-and-links": _vm.loyaltyStatusAndLinks,
                    "user-loyalty": _vm.userLoyalty,
                    "market-attributes": _vm.marketAttributes,
                    "product-detail": "",
                    "feature-flags": _vm.featureFlags
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isExclusive && _vm.checkedQualifications
              ? _c(
                  "div",
                  { staticClass: "ns-product-detail__exclusive" },
                  [
                    _vm.userIsQualified
                      ? _c(
                          "div",
                          { staticClass: "exclusive_title" },
                          [
                            _c("NsIcon", {
                              staticClass: "ns-product-detail__exclusive-icon",
                              attrs: { "icon-name": "icon-exclusive-offer" }
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.translations.exclusiveOfferTitle)
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.userIsQualified
                      ? _c("NsMessageAction", {
                          attrs: {
                            message: _vm.exclusiveOfferMessage,
                            "action-label": _vm.translations.signIn,
                            "action-type": "login"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "above-message",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "exclusive_title" },
                                      [
                                        _c("NsIcon", {
                                          staticClass:
                                            "ns-product-detail__exclusive-icon",
                                          attrs: {
                                            "icon-name": "icon-exclusive-offer"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ns-product-detail__exclusive-text"
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.translations
                                                    .exclusiveOfferTitle
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3230343223
                          )
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showVariantSelector || (!_vm.isBaseSku && !_vm.desktopAndUp)
              ? _c(
                  "div",
                  { staticClass: "ns-product-detail__selectors" },
                  [
                    _vm.showVariantSelector
                      ? _c("NsProductVariantSelector", {
                          staticClass: "ns-product-detail__variant-selector",
                          attrs: {
                            label: _vm.translations.variantDropdownLabel,
                            placeholder:
                              _vm.translations.variantDropdownPlaceholder,
                            "selected-sku": _vm.isBaseSku ? "" : _vm.sku,
                            type: _vm.translations.variantType,
                            disabled: false,
                            tall: !_vm.desktopAndUp,
                            "variant-skus": _vm.variantSkus,
                            variants: _vm.variants
                          },
                          on: { select: _vm.handleSelectVariant }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isBaseSku && !_vm.desktopAndUp
                      ? _c("NsProductQuantitySelector", {
                          staticClass: "ns-product-detail__quantity-selector",
                          class: {
                            "no-variant":
                              !_vm.showVariantSelector ||
                              _vm.hideVariantSelector
                          },
                          attrs: {
                            selected: _vm.quantity,
                            disabled: _vm.disableQuantitySelector,
                            "max-available": _vm.maxQuantity,
                            "inline-label":
                              _vm.phabletAndDown &&
                              (!_vm.showVariantSelector ||
                                _vm.hideVariantSelector),
                            translations: _vm.translations,
                            wide: ""
                          },
                          on: { select: _vm.handleQuantitySelect }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isBaseSku
              ? [
                  _c(
                    "div",
                    { staticClass: "ns-product-detail__actions" },
                    [
                      !_vm.isBaseSku && _vm.desktopAndUp
                        ? _c("NsProductQuantitySelector", {
                            attrs: {
                              selected: _vm.quantity,
                              disabled: _vm.disableQuantitySelector,
                              "max-available": _vm.maxQuantity,
                              translations: _vm.translations
                            },
                            on: { select: _vm.handleQuantitySelect }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "ns-product-detail__add-to-cart fluid primary-solid",
                          attrs: {
                            disabled: _vm.disableAddToCart,
                            "data-testid": "addToCart"
                          },
                          on: { click: _vm.handleAddToCart }
                        },
                        [
                          _c("NsIcon", {
                            attrs: { "icon-name": "icon-smallcart-empty" }
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.translations.addToCart) +
                              "\n          "
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.hideAdr
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "ns-product-detail__add-to-adr fluid secondary-outline",
                              attrs: {
                                disabled: _vm.disableAddToAdr,
                                "data-testid": "addToAdr"
                              },
                              on: { click: _vm.handleAddToAdr }
                            },
                            [
                              _c("NsIcon", {
                                attrs: { "icon-name": "icon-refresh" }
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.translations.addToAdr) +
                                  "\n          "
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.statusMessage
                    ? _c(
                        "div",
                        {
                          staticClass: "ns-product-detail__message",
                          attrs: {
                            "data-testid": "status-message",
                            "data-testid-value": _vm.statusMessageKey
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.statusMessage) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showPayLater
                    ? _c(
                        "div",
                        {
                          staticClass: "ns-product-detail__pay-later",
                          attrs: { "data-testid": "payLater" }
                        },
                        [
                          _c("NsPayPalPayLater", {
                            attrs: {
                              amount: _vm.payLaterAmount,
                              placement: "product"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.description
              ? _c("div", {
                  staticClass: "ns-product-detail__description",
                  attrs: { itemprop: "description" },
                  domProps: { innerHTML: _vm._s(_vm.description) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isSale
              ? _c("div", {
                  staticClass: "ns-product-detail__sales-event-text",
                  attrs: { itemprop: "salesEventText" },
                  domProps: { innerHTML: _vm._s(_vm.salesEventText) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.nettoWeight
              ? _c(
                  "div",
                  {
                    staticClass: "ns-product-detail__netto-weight",
                    attrs: { "data-testid": "nettoLabel" }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.translations.nettoWeight) +
                        "\n        "
                    ),
                    _c("span", {
                      attrs: { "data-testid": "nettoWeight" },
                      domProps: { innerHTML: _vm._s(_vm.nettoWeight) }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isBaseSku
              ? _c(
                  "div",
                  { staticClass: "ns-product-detail__shipping-refunds" },
                  [_vm._t("shipping")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isBaseSku
              ? _c(
                  "div",
                  { staticClass: "ns-product-detail__shipping-refunds" },
                  [_vm._t("refunds")],
                  2
                )
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      !_vm.hideInfo
        ? _c("div", { staticClass: "ns-product-detail__info" }, [
            _c(
              "div",
              { staticClass: "ns-product-detail__info-column" },
              _vm._l(_vm.columnOne, function(item) {
                return _c("NsProductDetailInfo", {
                  key: item.id,
                  attrs: {
                    title: item.title,
                    content: item.content,
                    "content-type": item.type
                  }
                })
              }),
              1
            ),
            _vm._v(" "),
            _vm.columnTwo.length
              ? _c(
                  "div",
                  { staticClass: "ns-product-detail__info-column" },
                  _vm._l(_vm.columnTwo, function(item) {
                    return _c("NsProductDetailInfo", {
                      key: item.id,
                      attrs: {
                        title: item.title,
                        content: item.content,
                        "content-type": item.type
                      }
                    })
                  }),
                  1
                )
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }